import { categories } from "@/mocks/resources";

export default function Categories() {
  return (
    <section id="category" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-medium text-accent-600">内容分类</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              全部分类速览
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            从动画到合集，按主题浏览更清晰。点进分类即可只看对应领域的可用资源。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-8">
          {categories.map((c) => (
            <button
              key={c.name}
              onClick={() => document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" })}
              className="group flex flex-col items-center gap-3 rounded-lg border border-background-200/80 bg-background-100/50 p-5 text-center transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-950">{c.name}</span>
              <span className="text-xs text-foreground-500">{c.count} 个资源</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}